import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PagesService } from '@services/pages.service';
import { SharedService } from '@services/shared.service';

@Component({
  selector: 'app-sdk-payment-reject',
  standalone: true,
  imports: [],
  templateUrl: './sdk-payment-reject.component.html',
  styleUrls: ['../../../../auth.scss'],
})
export class SdkPaymentRejectComponent {
  userId: string | null = null;
  sessionId: string | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private pageService: PagesService,
    private sharedService: SharedService
  ) {}

  ngOnInit(): void {
    const urlParams = new URLSearchParams(window.location.search);
    this.userId =
      urlParams.get('user_id') ||
      urlParams.get('userId') ||
      this.route.snapshot.paramMap.get('user_id');
    this.sessionId = urlParams.get('session_id') || urlParams.get('sessionId');

    this.checkSdkPayment(this.userId, this.sessionId);
  }

  goToHomepage() {
    this.router.navigate(['/']);
  }

  retryPayment() {
    window.history.back();
  }

  checkSdkPayment(user_id: string | null, session_id: string | null) {
    this.sharedService.showLoader();
    const payload = {
      user_id: user_id ? Number(user_id) : 0,
      session_id: session_id || '',
    };

    this.pageService.update('CHECK_SDK_PAYMENT', payload).subscribe({
      next: (response: any) => {
        this.sharedService.hideLoader();
        this.sharedService.createNotification('error', 'Payment was rejected');
      },
      error: (err) => {
        this.sharedService.hideLoader();
        this.sharedService.createNotification('error', err.message || err || 'Payment was rejected');
      },
    });
  }
}
